import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetOrganization = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `organizations/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const GetOrganizationById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `organizations/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateOrganization = async (v, id) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `organizations/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const CreateOrganization = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `organizations`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const DeleteOrganization = async (id, userId) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `organizations/${id}/${userId}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const PermanentDeleteOrganization = async (id) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `organizations/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const MultipleDeleteOrganization = async (v) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `organizations`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const DisableOrganization = async (v) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `organizations/`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const EnableOrganization = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `organizations/gets`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const ApproveOrganization = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `organizations/approve`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetColleges = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `organizations/getcollege`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}